(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('NewAchAccount', [
			'$filter',
			'BANK_ACCOUNT_TYPE_OPTIONS',
			'CheckoutFactory',
			'globalConfig',
			'InvestmentEntityFactory',
			'mixpanelFactory',
			'urlFactory',
			NewAchAccountFunction
		]);

	function NewAchAccountFunction(
		$filter,
		BANK_ACCOUNT_TYPE_OPTIONS,
		CheckoutFactory,
		globalConfig,
		InvestmentEntityFactory,
		mixpanelFactory,
		urlFactory) {
		
		var checkout = this;

		function buildAccountDetailsPayload() {
			return {
				accountType: checkout.accountType.value,
				bankName: checkout.bankName,
				accountNumber: checkout.accountNumber,
				accountNumberConfirm: checkout.accountNumberConfirm,
				routingNumber: checkout.routingNumber
			};
		}

		function buildPaymentMethodPayload(bankAccountId) {
			return {
				bankAccountId: bankAccountId,
				transactionType: 'ACH'
			};
		}

		checkout.linkAccountToOrderAndRedirect = function() {
			InvestmentEntityFactory.linkManualBankAccount(buildAccountDetailsPayload(), checkout.bankAccountForm)
				.then(function(data) {
					var failureRedirectUrl = '/reits/checkout/select-payment-method';
					CheckoutFactory.linkPaymentToOrder(checkout.orderGroupId, buildPaymentMethodPayload(data.id), failureRedirectUrl)
						.then(function() {
							urlFactory.redirect('/reits/checkout/acknowledgments');
						})
						.catch(function() {
							checkout.formSubmitted = false;
						});
				})
				.catch(function() {
					checkout.formSubmitted = false;
				});
		};

		checkout.onAccountTypeChange = function(accountType, numberOfInvestments) {
			if (checkout.isRiaCheckout === true) {
				if (accountType.value === 'SAVINGS') {
					checkout.savingsAccountSelected = true;
					checkout.bankAccountForm.accountType.$setValidity('accountType', false);

					mixpanelFactory.track('Savings Account Alert Shown', {
						'Investment Count': numberOfInvestments
					});
				} else {
					checkout.savingsAccountSelected = false;
					checkout.bankAccountForm.accountType.$setValidity('accountType', true);
				}
			}
		};

		checkout.$onInit = function() {
			angular.extend(checkout, globalConfig);

			checkout.bankAccountTypeOptions = BANK_ACCOUNT_TYPE_OPTIONS;
			checkout.accountType = $filter('findSelectedOption')(checkout.accountType, 'value', checkout.bankAccountTypeOptions);
			checkout.savingsAccountSelected = false;
		};
	}
})(window.angular);